import { useEffect, useState } from 'react';
import stripeService from '../../../services/stripeService';

export const TRIAL_DAYS = 7;
export const PAYWALL_ROUTE = '/paywall';

const PLAN_KEY = 'tigaly_plan';

export const planFrom = value => (value === 'lifetime' ? 'lifetime' : 'monthly');

/** The plan picked on the landing page (?plan=), kept until the paywall. */
export const rememberPlan = plan => {
  try {
    localStorage.setItem(PLAN_KEY, planFrom(plan));
  } catch {
    // private mode: the paywall falls back to monthly
  }
};

export const rememberedPlan = () => {
  try {
    return planFrom(localStorage.getItem(PLAN_KEY));
  } catch {
    return 'monthly';
  }
};

export const trialEndLabel = () =>
  new Date(Date.now() + TRIAL_DAYS * 864e5).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });

/** The live plans (prices and seats left) by key, or null until they load. */
export const useTigalyPlans = () => {
  const [plans, setPlans] = useState(null);

  useEffect(() => {
    stripeService
      .getStripePlans()
      .then(res => setPlans(Object.fromEntries((res?.data?.plans || []).map(plan => [plan.key, plan]))))
      .catch(() => setPlans({}));
  }, []);

  return plans;
};
